import React, { useMemo } from 'react';
import { List } from '@shakkerai/pro-components';
import { translate } from '@shakkerai/util-i18n';
import { convert2CompressedUrl } from '@shakkerai/util-image';
import { Icon } from '@shakkerai/components';
import { showImageGenerationInfo } from '../..';

const ImageCard = ({ data, isModelImage }) => {
  const { W: width, H: height } = data;

  const handleShowGenerationInfo = () => {
    showImageGenerationInfo(data.imageUuid || data.uuid, isModelImage ? 55 : null);
  };

  const userAvatar = data.avatar || data.userAvatar;
  const userName = data.userName || data.nickname;

  return (
    <div style={{ width, height }} className="group relative w-[158px] overflow-hidden bg-[#f2f4f6] rounded">
      <img draggable={false} className="w-full h-auto" src={convert2CompressedUrl(data.imageUrl, 320)} />
      <div className="opacity-0 group-hover:opacity-100 transition-opacity absolute bottom-0 left-0 flex items-center w-[158px] h-[60px] pt-[14px] px-3 bg-gradient-to-b from-black/0 to-black/60">
        {!userAvatar ? (
          <div className="w-5" />
        ) : (
          <img src={userAvatar} className="w-5 h-5 border border-white rounded-full object-cover" />
        )}
        {!userName ? (
          <div className="flex-1" />
        ) : (
          <span className="mx-1 flex-1 overflow-hidden whitespace-nowrap text-white text-ellipsis text-[11px]">
            {userName}
          </span>
        )}
        <button
          onClick={handleShowGenerationInfo}
          className="flex items-center justify-center h-5 px-2 bg-black/60 rounded-full"
        >
          <Icon className="shk-lora_xiangqing" color="#fff" fontSize={12} />
          <span className="ml-1 text-xs text-white">Info</span>
        </button>
      </div>
    </div>
  );
};

const NormalImageCard = ({ data }) => {
  return (
    <div className="flex items-stretch group relative overflow-hidden bg-[#f2f4f6] rounded">
      <img
        draggable={false}
        className="w-full h-auto max-h-[400px] object-cover"
        src={convert2CompressedUrl(data.imageUrl, 656)}
      />
      <div className="absolute inset-0 z-[1] border border-[#00000014] rounded" />
    </div>
  );
};

export const ImageList = React.memo(({ data = {}, withNormalLayout, showFooter = true, isModelImage }) => {
  const { items = [], loading = false } = data;

  const emptyText = useMemo(() => {
    return (
      <div className="flex flex-col items-center mt-24">
        <Icon className="shk-danchuang-gengduomoxing1" fontSize={32} color="#D7D7D7" />
        <span className="mt-4 text-xs text-[#adadad]">{translate('gallery_no_more')}</span>
      </div>
    );
  }, []);

  if (!items?.length) {
    if (!showFooter) return null;

    if (loading) {
      return (
        <div className="flex items-center justify-center mt-12 text-xs text-[#7f7f7f]">{translate('loading')}...</div>
      );
    }

    return <div className="flex items-center justify-center mt-12 text-xs text-[#7f7f7f]">{emptyText}</div>;
  }

  if (withNormalLayout) {
    return (
      <div className="space-y-2">
        {items.map((item) => (
          <NormalImageCard key={item.uuid} data={item} />
        ))}
      </div>
    );
  }

  return (
    <>
      <List
        data={items}
        columnWidth={158}
        renderItem={(item) => <ImageCard data={item} isModelImage={isModelImage} />}
      />
      {!showFooter ? null : loading ? (
        <div className="flex self-stretch items-center justify-center mb-4 text-xs text-[#7f7f7f]">
          {translate('loading')}...
        </div>
      ) : (
        <div className="flex items-center justify-center mt-4 mb-8">
          <div className="w-16 h-px bg-[#efefef]" />
          <span className="mx-3 text-[#d7d7d7] text-xs">{translate('gallery_no_more')}</span>
          <div className="w-16 h-px bg-[#efefef]" />
        </div>
      )}
    </>
  );
});
